'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  opacity: 0.7;\n  width: 100%;\n  left: 0;\n  top: 0;\n  height: 100%;\n  position: fixed;\n  z-index: 99999;\n  pointer-events: none;\n'], ['\n  opacity: 0.7;\n  width: 100%;\n  left: 0;\n  top: 0;\n  height: 100%;\n  position: fixed;\n  z-index: 99999;\n  pointer-events: none;\n']);

exports.default = SvgMask;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../helpers');

var hx = _interopRequireWildcard(_helpers);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SvgMaskWrapper = _styledComponents2.default.div(_templateObject);

function SvgMask(_ref) {
  var windowWidth = _ref.windowWidth,
      windowHeight = _ref.windowHeight,
      targetWidth = _ref.targetWidth,
      targetHeight = _ref.targetHeight,
      targetTop = _ref.targetTop,
      targetLeft = _ref.targetLeft,
      padding = _ref.padding,
      rounded = _ref.rounded,
      disableInteraction = _ref.disableInteraction,
      disableInteractionClassName = _ref.disableInteractionClassName;
  var width = hx.safe(targetWidth + padding * 2);
  var height = hx.safe(targetHeight + padding * 2);
  var top = hx.safe(targetTop - padding);
  var left = hx.safe(targetLeft - padding);
  return _react2.default.createElement(SvgMaskWrapper, null, _react2.default.createElement('svg', {
    width: windowWidth,
    height: windowHeight,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('defs', null, _react2.default.createElement('mask', {
    id: 'mask-main'
  }, _react2.default.createElement('rect', {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: 'white'
  }), _react2.default.createElement('rect', {
    x: left,
    y: top,
    width: width,
    height: height,
    fill: 'black'
  }), _react2.default.createElement('rect', {
    x: left - 1,
    y: top - 1,
    width: rounded,
    height: rounded,
    fill: 'white'
  }), _react2.default.createElement('circle', {
    cx: left + rounded,
    cy: top + rounded,
    r: rounded,
    fill: 'black'
  }), _react2.default.createElement('rect', {
    x: left + width - rounded + 1,
    y: top - 1,
    width: rounded,
    height: rounded,
    fill: 'white'
  }), _react2.default.createElement('circle', {
    cx: left + width - rounded,
    cy: top + rounded,
    r: rounded,
    fill: 'black'
  }), _react2.default.createElement('rect', {
    x: left - 1,
    y: top + height - rounded + 1,
    width: rounded,
    height: rounded,
    fill: 'white'
  }), _react2.default.createElement('circle', {
    cx: left + rounded,
    cy: top + height - rounded,
    r: rounded,
    fill: 'black'
  }), _react2.default.createElement('rect', {
    x: left + width - rounded + 1,
    y: top + height - rounded + 1,
    width: rounded,
    height: rounded,
    fill: 'white'
  }), _react2.default.createElement('circle', {
    cx: left + width - rounded,
    cy: top + height - rounded,
    r: rounded,
    fill: 'black '
  })), _react2.default.createElement('clipPath', {
    id: 'clip-path'
  }, _react2.default.createElement('rect', {
    x: 0,
    y: 0,
    width: windowWidth,
    height: top
  }), _react2.default.createElement('rect', {
    x: 0,
    y: top,
    width: left,
    height: height
  }), _react2.default.createElement('rect', {
    x: targetLeft + targetWidth + padding,
    y: top,
    width: hx.safe(windowWidth - targetWidth - left),
    height: height
  }), _react2.default.createElement('rect', {
    x: 0,
    y: targetTop + targetHeight + padding,
    width: windowWidth,
    height: hx.safe(windowHeight - targetHeight - top)
  }))), _react2.default.createElement('rect', {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: '#000000',
    mask: 'url(#mask-main)'
  }), _react2.default.createElement('rect', {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: '#000000',
    clipPath: 'url(#clip-path)',
    pointerEvents: 'auto'
  }), _react2.default.createElement('rect', {
    x: left,
    y: top,
    width: width,
    height: height,
    pointerEvents: 'auto',
    fill: 'transparent',
    display: disableInteraction ? 'block' : 'none',
    className: disableInteractionClassName
  })));
}

SvgMask.propTypes = {
  windowWidth: _propTypes2.default.number.isRequired,
  windowHeight: _propTypes2.default.number.isRequired,
  targetWidth: _propTypes2.default.number.isRequired,
  targetHeight: _propTypes2.default.number.isRequired,
  targetTop: _propTypes2.default.number.isRequired,
  targetLeft: _propTypes2.default.number.isRequired,
  padding: _propTypes2.default.number.isRequired,
  rounded: _propTypes2.default.number.isRequired,
  disableInteraction: _propTypes2.default.bool.isRequired,
  disableInteractionClassName: _propTypes2.default.string.isRequired
};